import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const CookiePolicyPage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/cookie-policy.md"
      title="Cookie Policy"
      description="Learn how admeru uses cookies and similar technologies on our platform, and how you can manage your preferences."
    />
  );
};
